import React, { useEffect } from 'react';
import { Box, Typography, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';

const FilterRadio = ({ name, values, value, label, onHandleChange }) => {
    useEffect(() => {
        if (!value) {
            onHandleChange(name, values[0], 'radio');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = e => {
        onHandleChange(name, e.target.value, 'radio');
    };

    return (
        <Box>
            <Box mb={1}>
                <Typography variant="body2">{label}</Typography>
            </Box>
            <Box display="flex" flexDirection="column">
                <RadioGroup name={name} defaultValue={values[0]} value={value} onChange={handleChange}>
                    {values.map((value, index) => (
                        <FormControlLabel key={index} value={value} control={<Radio />} label={value} />
                    ))}
                </RadioGroup>
            </Box>
        </Box>
    );
};

export default FilterRadio;
